import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/Login.vue';
import MainPage from '../components/MainPage.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'MainPage',
    component: MainPage
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('email') !== null;
  if (isAuthenticated) {
    // 如果用户已经通过身份验证，且要前往的页面是 Login 页面，则将用户重定向到根路径
    if (to.name == 'Login') {
      next({ path: '/' });
    } else {
      next(); // 如果用户已经通过身份验证，则无需重定向到login页面
    }
  } else {
    // 如果用户未通过身份验证，且要前往的页面不是 Login 页面，则将用户重定向到 Login 页面
    if (to.name !== 'Login') {
      next({ name: 'Login' });
    } else {
      next(); // 如果用户未通过身份验证，且要前往的是 Login 页面，则直接放行
    }
  }
});

export default router;
